import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = {
  class: "dashboard__content",
  style: {"height":"auto"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { style: {"align-self":"flex-start"} }, "Datasets", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"margin-bottom":"1rem"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600"} }, "Training accuracy:", -1)
const _hoisted_7 = { style: {"margin-bottom":"1rem"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600"} }, "Evaluation accuracy:", -1)
const _hoisted_9 = { class: "data-container" }
const _hoisted_10 = {
  key: 0,
  style: {"text-align":"left","font-size":"0.8em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_data_table = _resolveComponent("data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_drop_file),
      (_ctx.file)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "custom-button",
            style: {"margin-bottom":"1rem"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.train && _ctx.train(...args)))
          }, "Train model"))
        : _createCommentVNode("", true),
      (_ctx.trained && _ctx.file)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.trainingAccuracy.toFixed(2)) + "% ", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.evaluationAccuracy.toFixed(2)) + "% ", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_data_table),
        (_ctx.file && _ctx.file.type === 'txt')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.file.content, (sentence, rowKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'row-' + rowKey
                }, _toDisplayString(sentence), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}